import classNames from "classnames";
import {ReactNode} from "react";

import {FormLabel, FormLabelTypography} from "@/components/form/FormLabel.tsx";

import styles from "./CheckboxLabel.module.scss";

export interface CheckboxLabelProps {
  children?: ReactNode;
  className?: string;
  forId: string;
  helpText?: string;
  disabled?: boolean;
  labelTypography?: FormLabelTypography;
}

const CheckboxLabel = ({children, className, forId, disabled, helpText, ...rest}: CheckboxLabelProps) => {
  return (
    <FormLabel
      forId={forId}
      className={classNames(styles.checkboxLabel, {[styles.disabled]: disabled}, className)}
      helpText={helpText}
      {...rest}
    >
      {children}
    </FormLabel>
  );
};

CheckboxLabel.displayName = "CheckboxLabel";
export {CheckboxLabel};
